// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__L5YPg","main":"login_main__67nmk","title":"login_title__GQ4t2","msg":"login_msg__IkF5x"};